import React, { useState } from 'react';
import { Button, ShareWithManagerButton } from '@/components/Buttons';
import { BUTTON_LABELS } from '@/constants/labels';
import { cn } from '@/utils';
import { actionsContainerStyles } from '../Scorecard.styles';
import { IScorecardActions, ScorecardProps } from '../types';

export interface ActionsSectionProps {
	actions?: IScorecardActions;
	actionsLayout?: ScorecardProps['actionsLayout'];
	description?: string;
	handleShareWithManager: () => void;
	isLoading?: boolean;
	scoreCardId?: number;
	sessionId?: number;
	sharedWithManager?: boolean;
	showSkillScale?: boolean;
	size?: ScorecardProps['size'];
	userId?: string;
}

export const ActionsSection: React.FC<ActionsSectionProps> = ({
	actions,
	actionsLayout = 'horizontal',
	description,
	handleShareWithManager,
	isLoading = false,
	scoreCardId,
	sessionId,
	sharedWithManager,
	showSkillScale = true,
	size,
	userId,
}) => {
	const [isPending, setIsPending] = useState(false);
	if (!actions || (!actions.primary && !actions.secondary)) return null;

	const handlePrimaryActionClick = () => {
		setIsPending(true);
		actions.primary?.onClick?.();
	};

	return (
		<div
			className={cn(actionsContainerStyles({ layout: actionsLayout, size }), {
				'pt-2': description || showSkillScale,
				hidden:
					actions.primary?.className?.includes('hidden') &&
					actions.secondary?.className?.includes('hidden'),
			})}
		>
			{actions.primary && (
				<Button
					className={actions.primary.className}
					disabled={isLoading || actions.primary.disabled}
					iconRight={actions.primary.iconRight}
					isTransitioning={isPending}
					label={actions.primary.label}
					loading={actions.primary.loading}
					onClick={handlePrimaryActionClick}
					size="small"
					variant={actions.primary.variant || 'primary'}
				/>
			)}

			{actions.secondary && (
				<>
					{actions.secondary.label === BUTTON_LABELS.SHARE_WITH_MANAGER ? (
						<ShareWithManagerButton
							className={actions.secondary.className}
							disabled={isLoading || sharedWithManager}
							initialState={sharedWithManager === true ? 'shared' : 'initial'}
							onShare={handleShareWithManager}
							scoreCardId={Number(scoreCardId)}
							sessionId={sessionId}
							userId={userId}
						/>
					) : (
						<Button
							className={actions.secondary.className}
							disabled={isLoading || actions.secondary.disabled}
							iconRight={actions.secondary.iconRight}
							label={actions.secondary.label}
							onClick={actions.secondary.onClick}
							size="small"
							variant={actions.secondary.variant || 'link'}
						/>
					)}
				</>
			)}
		</div>
	);
};

ActionsSection.displayName = 'ActionsSection';

export default ActionsSection;
